export default "__VITE_ASSET__CCc6ZUdW__"